// src/mocks/mockBaseQuery.ts
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { networkDelay } from './delays'
import { handleMockRequest } from './handlers'

export const mockBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
) => {
  await networkDelay(api)
  const url = typeof args === 'string' ? args : args.url
  const method = typeof args === 'string' ? 'GET' : (args.method ?? 'GET')
  const body = typeof args === 'string' ? undefined : args.body
  const result = await handleMockRequest({ url, method, body, api })
  return result as { data: unknown } | { error: FetchBaseQueryError }
}
